import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/pc-builder/PcBuilderClient.tsx");
